<div class="input-wrapper" [class.disabled]="control.disabled" [class.error]="error" [ngClass]="{ focused: isFocused }">
  <label class="form-label" [ngClass]="{
    'inline-form-label-with-button-password': isPassword,
    'inline-form-label-with-button': !isPassword && (showButton || showTextButton),
    'inline-form-label-without-row-col': !isPassword && (showButton || showTextButton),
    'inline-form-label': !isPassword && !(showButton || showTextButton)
  }" 
  [style.right]="labelOffset ? labelOffset : null"
  
  *ngIf="label">{{ label }}</label>
    <!-- inline-form-label-with-button -->
    <div class="input-container">

      <span *ngIf="showSearchIcon" >
        <ng-template #loader>
          <img class="searchForm-wrap-loader loader" src="assets/ellipse.svg" alt="loader" draggable="false" />
        </ng-template>
        <img *ngIf="!isLoading; else loader" class="searchForm-wrap-icon" src="assets/search.svg" alt="search"  [class.dark]="isSearchGrey"
        draggable="false" />
      </span>

      <!-- [placeholder]="placeholder"  -->
      <input
      *ngIf="type !== 'text-area'"
        [class]="'input-field ' + inputClass"
        [type]="computedType()"
        [formControl]="control"
        [class.has-toggle]="showButton"
        [class.text-uppercase]="transformUpperCase"
        [class.has-label]="label"
        (focus)="onFocus();"
        (blur)="onBlur()"
        (input)="inputEvent.emit(control.value); inputWithEvent.emit($event)"
        (keypress)="keypressFn($event)"
        [mask]="inputMask"
        [dropSpecialCharacters]="unBindMaskedValue"
        [maxlength]="maxLength"
        [placeholder]="allowToShowPlaceHolder ? placeholder : ''"
        [id]="id"
        [readonly]="isInputReadOnly"
        (change)="onInputChange()"
        (keydown)="onInputKeydown($event)"
        autocomplete="new-password"
        [validation]="inputMaskValidation"
        [patterns]="isTimeMasking ? timePatterns : emptyPatterns"
        [style.text-transform]="textTransform"
        [style.text-align]="textAlign"
      />

      <!-- Multiline textarea input shown when type is text-area -->
        <textarea
        *ngIf="type === 'text-area'"
        class="input-field text-area-field"
        [placeholder]="placeholder"
        [formControl]="control"
        [class.text-uppercase]="transformUpperCase"
        [class.has-label]="label"
        (focus)="isFocused = true"
        (blur)="onBlur()"
        (input)="inputEvent.emit(control.value)"
        (keypress)="keypressFn($event)"
        [rows]="textAreaRow"                         
        (change)="onInputChange()"
        [style.resize]="textAreaResize"
        ></textarea>
  
      <!-- <eap-button
        *ngIf="showButton"
        [disabled]="control.disabled"
        (click)="onButtonClick()"
        [iconSm]="buttonIcon"
        [size]="'sm'"
        [error]="error"
      ></eap-button> -->

      <mat-icon *ngIf="showButton" (click)="onButtonClick()"  class="material-symbols-outlined drop-down-icon cursor-pointer cal-icon" [ngClass]="{ 'large-icon': showLargeIcon }" aria-hidden="true">
        {{ buttonIcon }}
      </mat-icon>

      <eap-button class="text-button cursor-pointer"
        *ngIf="showTextButton"
        variant="text"
        [label]="textButtonLabel"
        [customClass]="textButtonClass"
        (click)="onButtonClick()"
        >
      </eap-button>
    </div>
  
    <!-- <small class="assistive-text" *ngIf="assistiveText">
      <mat-icon *ngIf="assistiveIcon" class="material-symbols-outlined assistive-icon" aria-hidden="true">
        {{ assistiveIcon }}
      </mat-icon>
      {{ assistiveText }}
    </small> -->
  </div>
  